import * as React from "react";
import { ModelState } from "../../Models/ModelStateEnum";
import PbhRequestUnserviceableCreate from "./PbhRequestUnserviceableCreate";
import PbhRequestUnserviceableUpdate from "./PbhRequestUnserviceableUpdate";
import { useEffect, useState } from "react";
import PbhRequestUnserviceableView from "./PbhRequestUnserviceableView";

const PbhRequestUnserviceable = props => {
  const [tabType, setTabType] = useState(ModelState.Create);

  useEffect(() => {
    setTabType(props?.requestUnserviceableData === null ? ModelState.Create : ModelState.Edit);
  }, [props?.requestUnserviceableData]);

  switch (tabType) {
    case ModelState.Create:
      return (
        <PbhRequestUnserviceableCreate
          requestId={props.requestId}
          requestDetail={props?.requestDetailData}
          finalCallBack={props.parentCallBack}
          isPageDisabled={props.isPageDisabled}
        />
      );
    case ModelState.Edit:
      return (
        <PbhRequestUnserviceableUpdate
          requestId={props.requestId}
          requestDetail={props?.requestDetailData}
          unserviceable={props.requestUnserviceableData}
          finalCallBack={props.parentCallBack}
          isPageDisabled={props.isPageDisabled}
        />
      );
    default:
      return (
        <PbhRequestUnserviceableView
          requestId={props.requestId}
          requestDetail={props?.requestDetailData}
          unserviceable={props.requestUnserviceableData}
        />
      );
  }
};

export default PbhRequestUnserviceable;
